import React, { FC, ReactNode } from "react";
import { AuthProvider } from "react-oidc-context";

interface authProvider {
  children: ReactNode;
}

export const Provider: FC<authProvider> = ({ children }) => {
  const cognitoAuthConfig = {
    authority:
      "https://cognito-idp.eu-west-1.amazonaws.com/eu-west-1_5kOiNwan8",
    client_id: "5otsv3btiofanf4l0cn9elatq9",
    redirect_uri: "https://e-health-org.be/admin/auth-callback",
    response_type: "code",
    scope: "email openid",
  };

  return <AuthProvider {...cognitoAuthConfig}>{children}</AuthProvider>;
};
